import Badge from "ui/components/Badge/Badge";
import { FleetTireSetRow } from "services/api/fleet/tires/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { TIRE_TYPE_BACKGROUND } from "ui/modules/fleet/tires/pages/TireSetSearchPage/components/TireSetSearchResults/consts";

export const FLEET_VEHICLE_TIRE_SET_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleLocationClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    entityId: string,
    entityName: string
  ) => void,
  handleEditClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleDemountClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
   {
      title: "admin.fleet.vehicle.tire.set.search.code",
      key: "tire_code",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return <div className="flex gap-2 items-center">{row.code}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.tire.set.search.size",
      key: "tire_size",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const dimension = Array.from(
          new Set(
            row.childRows
              ?.map(r => `${r.width}/${r.height} R${r.radius}`)
              .filter(Boolean)
          )
        ).join(", ");
        return (
          <div className="text-md ">
            {dimension}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.tire.set.search.tiretype",
      key: "tire_type",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const tireType = row.childRows && row.childRows[0].tireType;
        return <div className="flex gap-2 items-center">{tireType && TIRE_TYPE_BACKGROUND(tireType?.id)} <div className="text-md">{tireType?.name}</div></div>;
      },
    },
    {
      title: "admin.fleet.vehicle.tire.set.search.manufacturer",
      key: "tire_manufacturer",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const tireManufacturers = Array.from(
          new Set(
            row.childRows
              ?.map(r => `${r.tireManufacturer?.name}`)
              .filter(Boolean)
          )
        ).join(", ");
        return (
          <div>
            <div className="text-md">{tireManufacturers}</div>
          </div>
        );
      },
    },
   
    {
      title: "admin.fleet.tire.set.search.location",
      key: "tire_location",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return <div className="inline-flex gap-3 items-center text-md font-medium truncate text-sky-600 hover:text-sky-900 text-sm cursor-pointer">{row.location ? <span className="" onClick={(e) => handleLocationClick(e, row.location.entityId, row.location.entityName)}>{row.location.destination}</span> : <></>}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.tire.set.search.isactive",
      key: "tire_active",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return <Badge text={row.isActive ? t("admin.yes") : t("admin.no")} variant={row.isActive ? "success" : "warning"} showDot />;
      },
    },

    {
      title: "",
      key: "tire_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const isOnVehicle = row.location?.entityName === "Vehicle";
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/pencil.svg"
              onClick={(e) => handleEditClick(e, row.id)}
            >
              Uredi
            </ButtonMenuItem>
            <ButtonMenuItem
              startIcon="/media/icons/refresh.svg"
              onClick={(e) => handleDemountClick(e, row.id)}
            >
              Demontaža
            </ButtonMenuItem>
            {!isOnVehicle && (
              <ButtonMenuItem
                startIcon="/media/icons/trash.svg"
                variant="remove"
                onClick={(e) => handleDeleteClick(e, row.id)}
              >
                Obriši
              </ButtonMenuItem>
            )}
          </ButtonMenu>
        );
      },
    },
  ];




export const FLEET_VEHICLE_TIRE_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "admin.fleet.vehicle.tire.search.size",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.tire.search.tiretype",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.tire.search.manufacturer",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.tire.search.dot",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.tire.search.profiledepth",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.string,
    },
  ];


